import barberImg from './Images/barber.svg'
import carpenterImg from './Images/carpenter.svg'
import electricianImg from './Images/electrician.svg'
import mechanicImg from './Images/mechanic.svg'
import painterImg from './Images/painter.svg'
import plumberImg from './Images/plumber.svg'



let categories=[
    {
        name:"barber",
        image: barberImg
    },
    {
        name:"carpenter",
        image: carpenterImg
    },
    {
        name:"electrician",
        image: electricianImg
    },
    {
        name:"mechanic",
        image: mechanicImg
    },
    
    {
        name:"painter",
        image: painterImg
    },
    {
        name:"plumber",
        image: plumberImg
    },

]

export default categories;